import Wrapper from '../Wrapper';
import { green, red } from '@ant-design/colors';
import { Button, Dropdown, Flex, Menu } from 'antd';
import * as React from 'react';
import {
  allowedPaymentMethods,
  paymentMethodsDisplayInfo,
  SubscriptionAttrs
} from '@next-is-free-monorepo/next-is-free-types';
import { apiV1 } from '../../utils/apiClient';
import { MutationOptions, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { paymentMethodsQueryOptions, subscriptionQueryOptions } from '../../utils/queryOptions';
import RoundMoreButton from '../../microcomponents/RoundMoreButton';
import { IconCreditCardOff, IconDots, IconPlug, IconPlus, IconTrash } from '@tabler/icons-react';
import CModal from '../CModal';
import { useState } from 'react';
import BgIcon from '../../microcomponents/BgIcon';

const PaymentMethodOverview = () => {

  const paymentMethods = useSuspenseQuery(paymentMethodsQueryOptions());
  const [deleteConfirm, setDeleteConfirm] = useState<undefined | string>(undefined);

  const queryClient = useQueryClient();

  async function updatePaymentMethod() {
    const url = await apiV1.get<string>(`/shop/stripe-billing-portal?flow_data_type=payment_method_update`);
    window.location.replace(url);
  }

  const deletePaymentMethod: MutationOptions = {
    mutationKey: ['delete-payment-method'],
    mutationFn: async () => {
      return await apiV1.delete(`/shop/payment-methods/${deleteConfirm}`);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['payment-methods'] });
      setDeleteConfirm(undefined);
    }
  };


  return (
    <Wrapper
      title={'Metodi di pagamento'}
      mt={20}
    >
      {!paymentMethods?.data?.data?.length ? (
        <>
          <BgIcon icon={<IconCreditCardOff />} color={'red'} />
          <h3 className={'font-medium text-red-500 mt-2'}>
            Nessun metodo di pagamento inserito
          </h3>
          <p>
            Se non inserisci un metodo di pagamento l'abbonamento sarà
            disattivato al termine della prova gratuita e il tuo negozio non
            sarà più disponibile.
          </p>
        </>
      ) : (
        <div>
          {paymentMethods?.data?.data?.map((paymentMethod) => {
              if (paymentMethod.type === 'sepa_debit' || paymentMethod.type === 'card') {
                return (
                  <div className={'bg-slate-100 p-2 rounded-md mb-2 flex justify-between'} key={paymentMethod.id}>
                    <p
                      className={'font-bold'}>{paymentMethodsDisplayInfo[paymentMethod.type].label} ····{paymentMethod?.[paymentMethod.type]?.last4}</p>
                    <Dropdown menu={{
                      items: [{
                        key: 1,
                        label: 'Elimina',
                        danger: true,
                        icon: <IconTrash size={14} />,
                        onClick: () => setDeleteConfirm(paymentMethod.id)
                      }]
                    }}>
                      <button>
                        <IconDots size={16} />
                      </button>
                    </Dropdown>
                  </div>
                );
              } else {
                return (<div />);
              }
            }
          )}
        </div>
      )}
      <div style={{ marginTop: 20, textAlign: 'right' }}>
        <Button onClick={updatePaymentMethod} icon={<IconPlus size={14}/>}>
          Aggiungi metodo di pagamento
        </Button>
      </div>
      <CModal mutationOptions={deletePaymentMethod} onClose={() => setDeleteConfirm(undefined)} open={!!deleteConfirm}
              icon={<IconCreditCardOff />} color={'red'}
              confirmButtonText={'Elimina'}
              title={'Eliminare metodo di pagamento?'}
              text={'Senza un metodo di pagamento valido il tuo abbonamento non potrà essere rinnovato.'}>

      </CModal>
    </Wrapper>
  );
};
export default PaymentMethodOverview;
